import React from 'react';
import { List, Typography } from 'antd';
import { useSelector } from 'react-redux';
import { ListViewStyled } from '../../../common/components/post-listing/styled';
import { v2Color } from '@theme/v2';

/**
 * Pure presentational render loop for REGA detail sections, extracted from
 * RegaDetailFields so the new REGA Ad License detail view can reuse the exact
 * section-header band + 3-column grid + "—" empty handling.
 *
 * Defaults reproduce the existing ListingDetailModal styling pixel-for-pixel.
 * Callers can override band/grid styling via props without affecting that modal.
 *
 * `sections`: [{ label, keys: [{ label, value }] }]
 */
const RegaDetailSections = ({ sections = [], bodyPadding, gridTemplate, gridGap = '16px 20px' }) => {
  const isMobile = useSelector((state) => state.app.AppConfig.isMobile);
  const padding = bodyPadding ?? (isMobile ? '0 16px' : '0 36px');
  const template = gridTemplate ?? (isMobile ? '1fr 1fr' : '1fr 1fr 1fr');

  return (
    <>
      {sections.map((item) => (
        <div key={item.label}>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: 10,
              minHeight: 44,
              background: v2Color('#F2FAFA'),
              borderRadius: 6,
              padding: '12px 20px',
              margin: '0 16px 12px',
            }}
          >
            <span style={{ color: '#4F4F4F', fontSize: 14, fontWeight: 700, lineHeight: '19.5px' }}>{item.label}</span>
          </div>
          <ListViewStyled
            split={false}
            className="mb-16"
            style={{ padding, '--grid-template': template, '--grid-gap': gridGap }}
          >
            {item.keys.map((key) => {
              const hasValue = key?.value != null && key?.value !== '' && key?.value !== '-';
              return (
                <List.Item
                  key={key.label}
                  className="px-0"
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'flex-start',
                    justifyContent: 'flex-start',
                    gap: 4,
                    padding: 0,
                    borderBlockEnd: 'none',
                  }}
                >
                  <Typography.Text style={{ color: '#9D9D9D', fontWeight: 400, fontSize: 14, lineHeight: '19.5px' }}>
                    {key?.label}
                  </Typography.Text>
                  <div style={{ color: '#000000E0', fontWeight: 600, fontSize: 14, lineHeight: '19.5px' }}>
                    {hasValue ? key.value : <span style={{ color: '#CCCCCC' }}>—</span>}
                  </div>
                </List.Item>
              );
            })}
          </ListViewStyled>
        </div>
      ))}
    </>
  );
};

export default RegaDetailSections;
